// ControlPictureFactory.js
import $ from 'jquery';

import BaseVisualControlFactory	from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import ListControlView from 'common-inputs/ListControlView.js';
import dummypic 		from 'dummypic.png';

//=============================================================================
//
// Creates an list control ref, given a factoryService
// parameter key and a layout position. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Brad Trebilcock, February 17, 2016
//
//=============================================================================
class ControlPictureFactory extends BaseVisualControlFactory {
    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        //adding silent(accessibility) to attributes.
        attributes.multiSelection = false;
        attributes.gridData = [{value: '1', caption: 'Item 1'}, {value: '2', caption: 'Item 2'}, {value: '3', caption: 'Item 3'}];
        attributes.selectFields = [{text: 'Value'}, {text: 'Caption'}];
        attributes.silent = false;
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= '~inputBorder';
        attributes.borderSize= '~inputBorder';
        attributes.cornerRadius= '~inputBorder';
        attributes.borderColor = '~inputBorderColor';
        attributes.styleBGColorText = '~inputBgColor';
        attributes.resizePadding = 2;
        attributes.Property = [{_id: 'captions', Item: [{_value: 'Item 1'}, {_value: 'Item 2'}, {_value: 'Item 3'}]}, {_id: 'values', Item: [{_value: '1'}, {_value: '2'}, {_value: '3'} ]}];
		attributes.minWidth = 10;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        return new ListControlView( { model: new ControlModel( attributes ), el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );
    }

}

const controlPictureFactory = new ControlPictureFactory();

export default controlPictureFactory;
